<div class="sidebar-backdrop" (click)="handleBackdropClick($event)"></div>
<aside
  class="sidebar sidebar-open"
  [class.sidebar-left]="position === 'left'"
  [class.sidebar-right]="position === 'right'"
  [style.width]="width"
>
  <!-- Header with close button -->
  @if (showLocation) {
    <div class="sidebar-location">
      <div class="location-content">
        <span class="location-label">Your Location</span>
        <button
          class="location-button"
          (click)="handleLocationClick($event)"
          aria-label="Change location"
        >
          <img src="/icons/location.svg" class="location-icon" alt="Location icon" />
          @if (selectedCity && selectedPincode) {
            <span class="location-text">
              {{ locationLabel }}: {{ selectedCity }}–{{ selectedPincode }}
            </span>
          } @else {
            <span class="location-text">Select Location</span>
          }
          <mat-icon class="expand-icon">expand_more</mat-icon>
        </button>
      </div>
      <button matIconButton aria-label="Close menu" (click)="close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  } @else if (showUserProfile) {
    <!-- User Profile Header -->
    <div class="sidebar-profile-header">
      <div class="profile-content">
        <div class="profile-avatar">
          <img src="icons/user.svg" alt="user" />
        </div>
        <div class="profile-info">
          <h3 class="profile-name">{{ userName || '' }}</h3>
          <p class="profile-phone">+91 {{ userPhone || '' }}</p>
        </div>
        <button class="edit-profile-btn" (click)="handleEditProfile()" aria-label="Edit profile">
          <img src="icons/edit-border-icon.svg" alt="edit" />
        </button>
      </div>
      <button matIconButton aria-label="Close menu" (click)="close()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  } @else {
    <div class="sidebar-location">
      <button matIconButton aria-label="Close menu" (click)="close()" class="close-btn-only">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <!-- Navigation Items -->
  <nav class="sidebar-nav">
    @for (item of navItems; track item.label; let i = $index) {
      <!-- Special Wallet Item (first item with wallet balance) -->
      @if (i === 0 && showWalletBalance) {
        <div
          class="nav-wallet-item"
          [class.active]="isItemActive(item)"
          (click)="handleNavItemClick(item, $event)"
        >
          <div class="wallet-content">
            <img
              [src]="isItemActive(item) ? '/icons/wallet-light.svg' : '/icons/wallet.svg'"
              alt="wallet"
              class="wallet-icon"
            />
            <div class="wallet-info">
              <span class="wallet-label">{{ item.label }}</span>
              <span class="wallet-balance">{{ walletLabel }}: ₹{{ walletBalance || 0 }}</span>
            </div>
          </div>
          <mat-icon class="nav-arrow">chevron_right</mat-icon>
        </div>
      } @else {
        <!-- Regular Nav Item with Icon -->
        <a
          class="nav-link-with-icon"
          [class.active]="isItemActive(item)"
          (click)="handleNavItemClick(item, $event)"
        >
          <div class="nav-link-content">
            @if (item.icon) {
              <mat-icon [svgIcon]="item.icon" class="nav-icon"></mat-icon>
            } @else if (item.key) {
              <mat-icon [svgIcon]="item.key" class="nav-icon"></mat-icon>
            }
            <span class="nav-label">{{ item.label }}</span>
          </div>
          @if (isItemActive(item)) {
            <mat-icon class="nav-arrow-active">chevron_right</mat-icon>
          }
        </a>
      }
    }

    <!-- Logout Item -->
    @if (showLogout) {
      <a class="nav-link-with-icon logout-item" (click)="handleLogout()">
        <div class="nav-link-content">
          <mat-icon svgIcon="logout" class="nav-icon"></mat-icon>
          <span class="nav-label">{{ logoutLabel }}</span>
        </div>
      </a>
    }
  </nav>

  @if (showHelpLegal && helpLegalItems.length > 0) {
    <div class="sidebar-section-header">
      <h3 class="section-title">{{ helpLegalTitle }}</h3>
    </div>
    <nav class="sidebar-nav sidebar-help-legal">
      @for (item of helpLegalItems; track item.label) {
        <a (click)="handleNavItemClick(item, $event)" class="nav-link">
          {{ item.label }}
        </a>
      }
    </nav>
  }

  @if (showFollowUs && socialIcons.length > 0) {
    <div class="sidebar-follow-us">
      <h3 class="follow-us-title section-title">{{ followUsTitle }}</h3>
      <div class="social-icons" style="padding-top: 16px">
        @for (social of socialIcons; track social.icon) {
          <a
            [href]="social.url"
            [attr.aria-label]="social.alt"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon-link"
          >
            <mat-icon [svgIcon]="social.icon"></mat-icon>
          </a>
        }
      </div>
    </div>
  }
</aside>
